'use client'

import { useEffect, useState } from 'react'

import { useConfig } from '@features/common.hooks/useConfig'

import { GTMDataLayer } from '../GTMDataLayer/GTMDataLayer'
import { GTMNoScript } from '../GTMScript/GTMNoScript'
import { GTMScript } from '../GTMScript/GTMScript'

/**
 * Google Tag Manager Client component.
 * Renders GTM scripts when GTM ID is configured.
 */
export const GoogleTagManagerClient = () => {
  const { gtm, env, version, service } = useConfig()
  const [isClient, setIsClient] = useState(false)

  // Only render on client to avoid hydration issues
  useEffect(() => {
    setIsClient(true)
  }, [])

  // Wait for client mount
  if (!isClient) {
    return null
  }

  // Only render GTM if GTM ID is configured
  if (!gtm.id) {
    return null
  }

  // Skip GTM (and OneTrust) on faucet-v2 subdomain / embedded routes
  const isFaucetV2 =
    typeof globalThis !== 'undefined' &&
    'location' in globalThis &&
    (globalThis.location.hostname.startsWith('faucet-v2') ||
      globalThis.location.pathname.startsWith('/faucet-v2'))

  if (isFaucetV2) {
    return null
  }

  return (
    <>
      <GTMDataLayer env={env} service={service} version={version} />
      <GTMScript gtmId={gtm.id} />
      <GTMNoScript gtmId={gtm.id} />
    </>
  )
}
